import { TranscriptCategories } from '../model/transcript-categories.model';

export function filterSummaryByParticipant(
    participant: string | null,
    categories: TranscriptCategories[],
): TranscriptCategories[] {
    if (participant == null || participant.trim().length === 0) {
        return [...categories];
    }

    return categories.map((c) => {
        const nextC = { ...c };

        nextC.subCategories = c.subCategories.map((sub) => {
            const nextSub = { ...sub };

            nextSub.transcripts = sub.transcripts.filter((t) => {
                // TODO revise. regex??
                return t.participants.some((p) => p === participant);
            });

            return nextSub;
        });

        return nextC;
    });
}
